<template>
  <div class="homeBgEff" ref="homeBgEff">
    <canvas id="myCanvas" ref="myCanvas"></canvas>
  </div>
</template>

<script>
import utils from '@/assets/utils'
export default {
  // name: 'HomeBgEff',

  data () {
    return {
      particleParam: {},
      areaParam: {},
      stopAnime: false
    }
  },
  mounted () {
    this.initData()
    window.onresize = () => {
      if (this.$refs.homeBgEff === undefined) { return }
      this.stopAnime = true
      setTimeout(() => {
        this.stopAnime = false
        this.initCanvas()
      }, 100)
    }
    this.initCanvas()
  },
  methods: {
    initData () {
      this.particleParam = {
        radMin: 1,
        radMax: 2,
        alphaMin: 0.6,
        alphaMax: 1
      }
      this.areaParam = {
        bottomSpd: 6,
        midSpd: 0.8,
        topSpd: 6,
        bottomHeightWeight: 15,
        midHeightWeight: 70,
        topHeightWeight: 15,
        minNum: 10,
        maxNum: 30 // 横向每100像素的粒子密度
      }
    },
    initCanvas () {
      const c = this.$refs.myCanvas
      const ele = this.$refs.homeBgEff
      // console.log(ele.offsetWidth)
      // console.log(window.screen.width)
      const width = ele.offsetWidth
      const height = ele.offsetHeight
      const ctx = c.getContext('2d')
      c.width = width
      c.height = height

      const particleGroup = this.particleGen([])

      // start
      window.requestAnimationFrame(() => {
        this.drawCanvas(ctx, width, height, particleGroup)
      })
    },
    drawCanvas (ctx, width, height, particleGroup) {
      if (this.$refs.homeBgEff === undefined) { return }
      if (this.stopAnime) { return }

      ctx.clearRect(0, 0, width, height)

      ctx.shadowBlur = 10
      ctx.shadowColor = 'rgba(255, 255, 255, 0.65)'

      particleGroup = this.particleGen(particleGroup)
      const nextParticleGroup = []

      for (let i = 0; i < particleGroup.length; i++) {
        const height = this.$refs.homeBgEff.offsetHeight
        const areaHeightWeightSum = this.areaParam.bottomHeightWeight + this.areaParam.midHeightWeight + this.areaParam.topHeightWeight
        const heightDistrArr = [height * (this.areaParam.midHeightWeight + this.areaParam.topHeightWeight) / areaHeightWeightSum, height * this.areaParam.topHeightWeight / areaHeightWeightSum]
        if (particleGroup[i].YPos < heightDistrArr[1]) {
          particleGroup[i].YPos -= this.areaParam.topSpd
        } else if (particleGroup[i].YPos < heightDistrArr[0]) {
          particleGroup[i].YPos -= this.areaParam.midSpd
        } else {
          particleGroup[i].YPos -= this.areaParam.bottomSpd
        }
        if (particleGroup[i].YPos > -20) {
          nextParticleGroup.push(particleGroup[i])
        }
        ctx.beginPath()
        ctx.arc(particleGroup[i].XPos, particleGroup[i].YPos, particleGroup[i].rad, 0, Math.PI * 2)
        ctx.closePath()
        ctx.fillStyle = 'rgba(196, 196, 196, ' + particleGroup[i].alpha + ')'
        ctx.fill()
      }

      // animate
      window.requestAnimationFrame(() => {
        this.drawCanvas(ctx, width, height, nextParticleGroup)
      })
    },
    particleGen (particleGroup) {
      const curNum = particleGroup.length
      const width = this.$refs.homeBgEff.offsetWidth
      const minNum = this.areaParam.minNum
      const maxNum = this.areaParam.maxNum
      const randNum = utils.randomNum(0, 10000)
      const _this = this

      let genPerc
      if (curNum < minNum * width / 100) {
        genPerc = 10000
      } else if (curNum > maxNum * width / 100) {
        genPerc = 0
      } else {
        genPerc = (maxNum * width / 100 - curNum) / (maxNum * width / 100 - minNum * width / 100) * 10000
      }

      if (randNum < genPerc) {
        particleGroup.push(newParticle(this.particleParam))
      }
      return particleGroup

      function newParticle (particleParam) {
        const particle = {}
        const width = _this.$refs.homeBgEff.offsetWidth
        particle.XPos = utils.randomNum(0, width)
        particle.YPos = _this.$refs.homeBgEff.offsetHeight
        particle.rad = utils.randomNum(particleParam.radMin, particleParam.radMax)
        particle.alpha = utils.randomNum(particleParam.alphaMin * 10000, particleParam.alphaMax * 10000) / 10000

        return particle
      }
    }
  }
}

</script>

<style scoped lang="scss">
.homeBgEff {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 33%;
  /*display: none;*/
  // background-color: rgba(0,255,255,0.3);
}

</style>
